import { render, staticRenderFns } from "./SideNavigatorComponent.vue?vue&type=template&id=7b027066&scoped=true&"
import script from "./SideNavigatorComponent.vue?vue&type=script&lang=js&"
export * from "./SideNavigatorComponent.vue?vue&type=script&lang=js&"
import style0 from "./SideNavigatorComponent.vue?vue&type=style&index=0&id=7b027066&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b027066",
  null
  
)

export default component.exports